import publicRoutes from "~/config/publicRoutes";

export default defineNuxtRouteMiddleware(async (to, from) => {
  // Skip auth middleware if route is configured to not require authentication
  if (publicRoutes.includes(to.path)) {
    return;
  }

  // The session lives in an httpOnly cookie, so the store can only resolve the
  // authenticated user on the client (via /api/verify). Server-side rendering of
  // a protected route is harmless on its own — the data it renders comes from
  // the API proxy, which enforces the session server-side — and the guard below
  // runs as soon as the client takes over.
  if (import.meta.server) {
    return;
  }

  const authStore = useAuthStore();
  const { loggedIn, isLoading } = storeToRefs(authStore);

  // Wait for the initial server verification to finish, then for any auth
  // operation still in flight. The refs are read *after* those awaits so the
  // guard sees the settled state instead of a snapshot taken before them.
  await authStore.awaitHydration();
  await until(isLoading).toBe(false);

  // Redirect the user to the sign-out flow if they're not authenticated; it
  // clears any residual client state before returning them to /signin.
  if (!loggedIn.value) {
    return navigateTo("/signout", { replace: true, external: true });
  }
});
